<template>
  <el-card class="box-card">
    <div slot="header" class="flex justify-between">
      <span>秒杀订单</span>
      <el-button
        type="primary"
        size="small"
        class="float-right"
        @click="_toSeckillOrderPage"
      >管理</el-button>
    </div>
    <div class="table-container">
      <el-table
        :data="shopOrderSeckillInfo.orders"
        style="width: 100%"
        height="450"
        border
      >
        <el-table-column prop="prodName" label="商品名称" align="center"></el-table-column>
        <el-table-column prop="buyerName" label="购买者" align="center"></el-table-column>
        <el-table-column prop="goodsNum" label="购买数量" align="center"></el-table-column>
        <el-table-column prop="killPrice" label="秒杀金额" align="center"></el-table-column>
        <el-table-column prop="createTime" label="购买时间" align="center"></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{scope.row.state == 'C'?'完成':'待支付'}}
          </template>
        </el-table-column>
        <el-table-column prop="endTime" label="截止时间" align="center"></el-table-column>
      </el-table>
      <el-pagination
        class="pagination-container"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-size="pagination.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
  </el-card>
</template>

<script>
import { getProductSeckillOrderList } from '@/api/order/shopOrderApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ShopOrderSeckill',
  data() {
    return {
      shopOrderSeckillInfo: {
        orders: [],
        link: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 7,
        total: 0
      }
    }
  },
  created() {
    this._loadShopOrderSeckillData(this.pagination.currentPage, this.pagination.pageSize)
  },
  methods: {
    _toSeckillOrderPage() {
      window.open('/#/pages/group/productSeckillOrder?tab=秒杀订单')
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this._loadShopOrderSeckillData(val, this.pagination.pageSize)
    },
    async _loadShopOrderSeckillData(page, row) {
      const shopId = await getShopId()
      const params = {
        shopId,
        page,
        row
      }

      getProductSeckillOrderList(params).then(res => {
        this.shopOrderSeckillInfo.orders = res.data
        this.pagination.total = res.records
      }).catch(() => {
        console.log('请求失败处理')
        console.log(shopId)
      })
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.float-right {
  float: right;
}
.table-container {
  height: 450px;
  overflow-y: auto;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>